import React, { Fragment, useState, useEffect } from 'react';
import { Col } from 'reactstrap'
import { Menu } from 'react-feather'
import { Link } from 'react-router-dom'
import './StyleCardHeader.css';
//StyleCardHeader

const Leftbar = (props) => {
  const [sidebartoggle, setSidebartoggle] = useState(() => {
    const saved = localStorage.getItem('sidebartoggle');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const sidebarState = (isOpen) => {
    const pageHeader = document.querySelector(".page-header");
    const sidebarWrapper = document.querySelector(".sidebar-wrapper");

    if (!pageHeader || !sidebarWrapper) return;

    if (!isOpen) {
      pageHeader.classList.add("close_icon");
      sidebarWrapper.classList.add("close_icon");
    } else {
      pageHeader.classList.remove("close_icon");
      sidebarWrapper.classList.remove("close_icon");
    }
  };

  useEffect(() => {

    setTimeout(() => sidebarState(sidebartoggle), 50);
    setTimeout(() => sidebarState(sidebartoggle), 150);

  }, []);


  useEffect(() => {
    localStorage.setItem('sidebartoggle', JSON.stringify(sidebartoggle));
    sidebarState(sidebartoggle);
  }, [sidebartoggle]);


  const responsive_openCloseSidebar = () => {
    setSidebartoggle(prev => !prev);
  };



  return (
    <Fragment>
      <div className="header-logo-wrapper " id="out_side_click">
        <div className="logo-wrapper">
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
            <div style={{ width: 155, height: 30 }}  >
              <img src={require("../../assets/images/loginHelenLabs/TomaDeMuestra/LogoHelenLabs.svg")} alt="helenLogo" style={{ width: "100%" }} />

              {/* <h4><img src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} alt="helenLogo" style={{ width: "8%" }} /> <label className='LabelLoginH'>&nbsp;&nbsp;HELEN</label> <label className='LabelLogin2H'>LABS</label> </h4> */}
            </div>
            {/* <img className="img-fluid for-light" src={require("../../assets/images/logo/logo.png")} alt="" />
            <img className="img-fluid for-dark" src={require("../../assets/images/logo/logo_dark.png")} alt="" /> */}
          </Link>
        </div>
        <div className="toggle-sidebar" onClick={responsive_openCloseSidebar}  style={window.innerWidth <= 991 ? { display: "block" } : { display: "none" }}>
          <Menu className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
        </div>


      </div>
      <Col className="left-header horizontal-wrapper pl-0">
        <ul className="horizontal-menu">
       
        </ul>
      </Col>
    </Fragment>
  );
}

export default Leftbar;

